// extracted by mini-css-extract-plugin
export default {"contenedor-titulo":"estilos_contenedor-titulo__NgPjQ","titulo":"estilos_titulo__3r28H","pleca-horizontal":"estilos_pleca-horizontal__A2BXp"};